"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.executeGraphQLQuery = exports.executeGraphQLMutation = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _headers = require("next/headers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var executeGraphQLQuery = exports.executeGraphQLQuery = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (query, variables, selector, token) {
    var _process$env$NEXT_APP, _process;
    var revalidateCache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var returnErrors = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var headers = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    var expirationTime = (_process$env$NEXT_APP = (_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.NEXT_APP_STATIC_CONTENT_CACHE_TTL) !== null && _process$env$NEXT_APP !== void 0 ? _process$env$NEXT_APP : 0;
    var cacheOptions = revalidateCache ? {
      cache: 'no-cache'
    } : {
      next: {
        revalidate: Number(expirationTime)
      }
    };
    try {
      var _data, _data2, _data3, _data4, _data5;
      var headersObj = getHeaders(token, headers);
      var fetchResponse;
      var data;
      if (isServerSide() && isAppRouter()) {
        var {
          cachedFetch
        } = yield Promise.resolve().then(() => _interopRequireWildcard(require('./cachedFetch')));
        fetchResponse = yield cachedFetch(getEndpoint(), JSON.stringify(headersObj), JSON.stringify({
          query,
          variables
        }), JSON.stringify(cacheOptions));
        if (!fetchResponse) {
          return null;
        }
        data = fetchResponse;
      } else {
        fetchResponse = yield fetch(getEndpoint(), _objectSpread({
          method: 'POST',
          headers: headersObj,
          body: JSON.stringify({
            query,
            variables
          })
        }, cacheOptions));
        if (!fetchResponse.ok) {
          return null;
        }
        data = yield fetchResponse.json();
      }
      if (!revalidateCache && ((_data = data) === null || _data === void 0 || (_data = _data.errors) === null || _data === void 0 ? void 0 : _data.length) > 0) {
        fetchResponse = yield fetch(getEndpoint(), {
          method: 'POST',
          headers: headersObj,
          body: JSON.stringify({
            query,
            variables
          }),
          next: {
            revalidate: 1
          }
        });
        if (!fetchResponse.ok) {
          return null;
        }
        data = yield fetchResponse.json();
      }
      if ((_data2 = data) !== null && _data2 !== void 0 && _data2.errors && ((_data3 = data) === null || _data3 === void 0 || (_data3 = _data3.errors) === null || _data3 === void 0 ? void 0 : _data3.length) > 0) {
        console['error'](query, variables, data.errors);
      }
      if (!returnErrors && (!((_data4 = data) !== null && _data4 !== void 0 && _data4.data) || ((_data5 = data) === null || _data5 === void 0 || (_data5 = _data5.errors) === null || _data5 === void 0 ? void 0 : _data5.length) > 0)) {
        return null;
      }
      return selector(data);
    } catch (error) {
      console['error'](query, variables, error);
      return null;
    }
  });
  return function executeGraphQLQuery(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var executeGraphQLMutation = exports.executeGraphQLMutation = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (mutation, variables, selector, token) {
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    try {
      var _result$errors;
      var headersObj = getHeaders(token, headers);
      var res = yield fetch(getEndpoint(), {
        method: 'POST',
        headers: headersObj,
        body: JSON.stringify({
          query: mutation,
          variables
        }),
        cache: 'no-cache'
      });
      if (!res.ok) {
        return null;
      }
      var result = yield res.json();
      if (result !== null && result !== void 0 && result.errors && (result === null || result === void 0 || (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors.length) > 0) {
        console['error'](mutation, variables, result.errors);
      }
      return selector(result);
    } catch (error) {
      console['error'](mutation, variables, error);
      return null;
    }
  });
  return function executeGraphQLMutation(_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();
var isServerSide = () => typeof window === 'undefined';
var getEndpoint = () => {
  var _process2, _process$env$NEXT_PUB2, _process4;
  if (isServerSide() && ((_process2 = process) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.NEXT_ENABLE_SERVER_APOLLO_GRAPHQL_ENDPOINT) === 'true') {
    var _process$env$NEXT_PUB, _process3;
    return (_process$env$NEXT_PUB = (_process3 = process) === null || _process3 === void 0 || (_process3 = _process3.env) === null || _process3 === void 0 ? void 0 : _process3.NEXT_PUBLIC_SERVER_APOLLO_GRAPHQL_ENDPOINT) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
  }
  return (_process$env$NEXT_PUB2 = (_process4 = process) === null || _process4 === void 0 || (_process4 = _process4.env) === null || _process4 === void 0 ? void 0 : _process4.NEXT_PUBLIC_GRAPHQL_ENDPOINT) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : '';
};
var getHeaders = function getHeaders(token) {
  var _process$env$NEXT_PUB3, _process5, _process$env$NEXT_PUB4, _process6, _nextHeaders$get, _nextHeaders$get2;
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread(_objectSpread({
    'Content-Type': 'application/json',
    'apollographql-client-name': (_process$env$NEXT_PUB3 = (_process5 = process) === null || _process5 === void 0 || (_process5 = _process5.env) === null || _process5 === void 0 ? void 0 : _process5.NEXT_PUBLIC_APP_NAME) !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : '',
    'apollographql-client-version': (_process$env$NEXT_PUB4 = (_process6 = process) === null || _process6 === void 0 || (_process6 = _process6.env) === null || _process6 === void 0 ? void 0 : _process6.NEXT_PUBLIC_APOLLO_CLIENT_VERSION) !== null && _process$env$NEXT_PUB4 !== void 0 ? _process$env$NEXT_PUB4 : ''
  }, isServerSide() && isAppRouter() ? {
    'x-forwarded-for': (_nextHeaders$get = (0, _headers.headers)().get('x-forwarded-for')) !== null && _nextHeaders$get !== void 0 ? _nextHeaders$get : '',
    'True-Client-IP': (_nextHeaders$get2 = (0, _headers.headers)().get('True-Client-IP')) !== null && _nextHeaders$get2 !== void 0 ? _nextHeaders$get2 : ''
  } : {}), headers), token && {
    Authorization: "Bearer ".concat(token)
  });
};
var isAppRouter = () => {
  try {
    (0, _headers.headers)();
    return true;
  } catch (_unused) {
    return false;
  }
};